import colors from '../colors';
import * as React from 'react';
import styled from 'styled-components';
import Message from './Message';

interface Props {
    button: string;
    className?: string;
    onClick: (val: any) => void;
}
interface State {}

class ChoiceButton extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e: React.MouseEvent<HTMLButtonElement>) {
        this.props.onClick(this.props.button);
    }

    render() {
        const { button, className } = this.props;

        return (
            <Wrapper className={className} onClick={this.handleClick} type="button">
                {button}
            </Wrapper>
        );
    }
}

export default ChoiceButton;

const Wrapper = styled.button`
    margin-right: 0.5em;
    margin-top: 0.5em;
    margin-bottom: 0;
    background-color: white;
    border-radius: 1em;
    border: 1px solid ${colors.green};
    color: ${colors.green};
    padding: 5px 10px;
    cursor: pointer;
    transition: all 0.1s ease-in;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: none;
    height: auto;
    line-height: 1.4;
    font-weight: 400;
    letter-spacing: 0;

    &:focus {
        outline: none;
    }
    &:hover {
        transform: scale(1.05);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
        color: ${colors.green};
        border: 1px solid ${colors.green};
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/ChoiceButton.tsx